const SearchBoxComponent = function() {
    const classMap = {
        collectionGroupName: ".js-search-box__collection-group-name",
        collectionGroupOption: ".js-search-box__collection-group-option",
        inputs: {
            collectionGroup: ".js-search-box__collection-group",
            collection: ".js-search-box__collection"
        }
    };

    let $currentCollectionGroup = $(), $collectionGroupName, $collectionGroupOptions, $collectionGroupInput, $collectionInput;

    let $currentContext = $();

    function setCollectionGroup($selectedCollectionGroup) {
        $selectedCollectionGroup.hide();
        $currentCollectionGroup.show();

        const data = $selectedCollectionGroup.data();
        $collectionGroupName.text(data.collectionGroupName);
        $collectionGroupInput.val(data.collectionGroupId);
        $collectionInput.val(data.collectionId);

        $currentCollectionGroup = $selectedCollectionGroup;
    }

    function bindEvents() {
        $collectionGroupOptions.on("click", function() {
            const $groupOption = $(this);
            setCollectionGroup($groupOption)
        });
    }

    function parseContext() {
        $collectionGroupName = $(classMap.collectionGroupName, $currentContext);
        $collectionGroupOptions = $(classMap.collectionGroupOption, $currentContext);
        $collectionGroupInput = $(classMap.inputs.collectionGroup, $currentContext);
        $collectionInput = $(classMap.inputs.collection, $currentContext);

    }

    this.init = function ($context) {
        $currentContext = $context || $currentContext;

        parseContext();
        bindEvents();
        var $initialCollectionGroup = $collectionGroupOptions.eq(0);
        setCollectionGroup($initialCollectionGroup);
    };
};

module.exports = SearchBoxComponent;
